"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importStar(require("react"));

var ksys_app_template_1 = require("@kurtosys/ksys-app-template");

var mobx_react_1 = require("mobx-react");

var shared_1 = require("../../../shared");

var Asset_1 = require("../Asset/Asset");

var StyledImage_1 = __importDefault(require("./styledComponents/StyledImage"));

var Image_meta_1 = require("./Image.meta");

var Image =
/** @class */
function (_super) {
  __extends(Image, _super);

  function Image(props) {
    var _this = _super.call(this, props) || this;

    _this.categoryKey = Image_meta_1.IMAGE_CATEGORY_KEY;
    _this.componentKey = Image_meta_1.IMAGE_COMPONENT_KEY;
    return _this;
  }

  Image.prototype.assetExists = function (assetContext) {
    var asset = this.props.asset;
    return asset && assetContext.hasAsset(asset);
  };

  Image.prototype.showImage = function (assetContext) {
    var src = this.props.src;
    return this.assetExists(assetContext) || !ksys_app_template_1.utils.typeChecks.isNullOrEmpty(src);
  };

  Image.prototype.prefixBaseUrl = function (assetContext) {
    var baseUrl = this.baseUrl(assetContext);
    var srcPart = this.srcPart(assetContext);

    if (ksys_app_template_1.utils.typeChecks.isNullOrEmpty(baseUrl) || ksys_app_template_1.utils.typeChecks.isBase64File(srcPart)) {
      return false;
    }

    if (srcPart.toLowerCase().startsWith('http://') || srcPart.toLowerCase().startsWith('https://')) {
      return false;
    }

    return baseUrl.toLowerCase().startsWith('http://') || baseUrl.toLowerCase().startsWith('https://');
  };

  Image.prototype.baseUrl = function (assetContext) {
    var baseUrl = this.props.baseUrl;
    var assetBaseUrl = assetContext && assetContext.baseUrl();
    return baseUrl || assetBaseUrl || '';
  };

  Image.prototype.srcPart = function (assetContext) {
    var _a = this.props,
        asset = _a.asset,
        src = _a.src;
    var response = '';

    if (!ksys_app_template_1.utils.typeChecks.isNullOrEmpty(src)) {
      response = src;
    } else if (asset) {
      response = assetContext.getAsset(asset);
    }

    return response;
  };

  Image.prototype.src = function (assetContext) {
    var baseUrl = this.baseUrl(assetContext);
    var srcPart = this.srcPart(assetContext);

    if (this.prefixBaseUrl(assetContext)) {
      baseUrl = baseUrl.endsWith('/') ? baseUrl : baseUrl + "/";
      srcPart = srcPart.startsWith('/') ? srcPart.substr(1) : srcPart;
      return "" + baseUrl + srcPart;
    }

    return srcPart;
  };

  Object.defineProperty(Image.prototype, "alt", {
    get: function get() {
      var _a = this.props.alt,
          alt = _a === void 0 ? '' : _a;

      if (typeof alt !== 'string') {
        return alt;
      }

      return react_1.default.createElement("span", {
        dangerouslySetInnerHTML: {
          __html: alt
        }
      });
    },
    enumerable: true,
    configurable: true
  });

  Image.prototype.render = function () {
    var _this = this;

    var _a = this.props,
        className = _a.className,
        src = _a.src,
        asset = _a.asset,
        baseUrl = _a.baseUrl,
        onClick = _a.onClick,
        props = __rest(_a, ["className", "src", "asset", "baseUrl", "onClick"]);

    return react_1.default.createElement(Asset_1.AssetContext.Consumer, null, function (assetContext) {
      return react_1.default.createElement(react_1.Fragment, null, _this.showImage(assetContext) && react_1.default.createElement(StyledImage_1.default, __assign({
        className: className,
        src: _this.src(assetContext),
        onClick: onClick
      }, props)), !_this.showImage(assetContext) && _this.alt);
    });
  };

  Image.contextType = Asset_1.AssetContext;
  Image = __decorate([mobx_react_1.observer], Image);
  return Image;
}(shared_1.ComponentBase);

exports.Image = Image;
exports.default = shared_1.InjectedStyledComponent(Image, Image_meta_1.IMAGE_CATEGORY_KEY, Image_meta_1.IMAGE_COMPONENT_KEY);